import { formatDate } from '@angular/common';
import { ElementRef, EventEmitter, Renderer2, RendererFactory2, } from '@angular/core';
import { BASE_TOOLBAR_FORMATS, ICON_LIST, QuillToolbarFormatType } from './constants';
import { SvgSpriteService } from 'Angular/services/svg-sprite.service';
import { IconDirective } from 'Angular/features/directives/icon/icon.directive';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/svg-sprite.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../directives/icon/icon.directive";
import * as i4 from "@angular/forms";
const _c0 = ["quillEditorContainer"];
const _c1 = ["quillToolbarContainer"];
const _c2 = ["iconContainer"];
const _c3 = a0 => ({ "ql-expanded": a0 });
function TextEditComponent_div_0_ng_container_2_select_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "select", 19);
    i0.ɵɵelement(1, "option", 20)(2, "option", 21)(3, "option", 22)(4, "option", 23);
    i0.ɵɵelementEnd();
} }
function TextEditComponent_div_0_ng_container_2_button_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 24);
} }
function TextEditComponent_div_0_ng_container_2_button_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 25);
} }
function TextEditComponent_div_0_ng_container_2_button_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 26);
} }
function TextEditComponent_div_0_ng_container_2_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function TextEditComponent_div_0_ng_container_2_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.addDynamicDate()); });
    i0.ɵɵelementEnd();
} }
function TextEditComponent_div_0_ng_container_2_button_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 28);
} }
function TextEditComponent_div_0_ng_container_2_button_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 29);
} }
function TextEditComponent_div_0_ng_container_2_button_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 30);
} }
function TextEditComponent_div_0_ng_container_2_button_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 31);
} }
function TextEditComponent_div_0_ng_container_2_span_11_For_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵlistener("click", function TextEditComponent_div_0_ng_container_2_span_11_For_6_Template_span_click_0_listener() { const icon_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.selectIcon(icon_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", icon_r5);
} }
function TextEditComponent_div_0_ng_container_2_span_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 32, 2)(2, "button", 33);
    i0.ɵɵlistener("mousedown", function TextEditComponent_div_0_ng_container_2_span_11_Template_button_mousedown_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.toggleIcons()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 35);
    i0.ɵɵrepeaterCreate(5, TextEditComponent_div_0_ng_container_2_span_11_For_6_Template, 2, 1, "span", 36, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3, ctx_r1.showIcons));
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r1.iconList);
} }
function TextEditComponent_div_0_ng_container_2_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 39);
    i0.ɵɵlistener("mousedown", function TextEditComponent_div_0_ng_container_2_button_12_Template_button_mousedown_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.showAddLink()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 40);
    i0.ɵɵelementEnd();
} }
function TextEditComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "container-element", 7);
    i0.ɵɵtemplate(2, TextEditComponent_div_0_ng_container_2_select_2_Template, 5, 0, "select", 8)(3, TextEditComponent_div_0_ng_container_2_button_3_Template, 1, 0, "button", 9)(4, TextEditComponent_div_0_ng_container_2_button_4_Template, 1, 0, "button", 10)(5, TextEditComponent_div_0_ng_container_2_button_5_Template, 1, 0, "button", 11)(6, TextEditComponent_div_0_ng_container_2_button_6_Template, 1, 0, "button", 12)(7, TextEditComponent_div_0_ng_container_2_button_7_Template, 1, 0, "button", 13)(8, TextEditComponent_div_0_ng_container_2_button_8_Template, 1, 0, "button", 14)(9, TextEditComponent_div_0_ng_container_2_button_9_Template, 1, 0, "button", 15)(10, TextEditComponent_div_0_ng_container_2_button_10_Template, 1, 0, "button", 16)(11, TextEditComponent_div_0_ng_container_2_span_11_Template, 7, 3, "span", 17)(12, TextEditComponent_div_0_ng_container_2_button_12_Template, 2, 0, "button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const format_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", format_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.SIZE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.BOLD);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.ITALIC);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.UNDERLINE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.DATE_EMBED);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.LINK);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.BULLET);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.BULLET);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.IMAGE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.YCNICON);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.TOOLBAR_TYPES.TARGET_LINK);
} }
function TextEditComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 1);
    i0.ɵɵtemplate(2, TextEditComponent_div_0_ng_container_2_Template, 13, 12, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.formats);
} }
function TextEditComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function TextEditComponent_Conditional_1_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.linkHref, $event) || (ctx_r1.linkHref = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "select", 42);
    i0.ɵɵtwoWayListener("ngModelChange", function TextEditComponent_Conditional_1_Template_select_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.linkTarget, $event) || (ctx_r1.linkTarget = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementStart(3, "option", 43);
    i0.ɵɵtext(4, "New Tab");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "option", 44);
    i0.ɵɵtext(6, "Self");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 45);
    i0.ɵɵlistener("click", function TextEditComponent_Conditional_1_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addLink()); });
    i0.ɵɵtext(8, "Add Link");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.linkHref);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.linkTarget);
} }
function TextEditComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 5);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.name)("value", ctx_r1.outputString);
} }
/**
 *
 * Text Edit Component
 *
 * Allows text edition with a WYSIWYG editor. Text is saved as HTML. To be used in text edit modals.
 *
 *
 * Input Properties:
 *  text: HTML string that will be edited.
 *  extraFormats: A list of quill js toolbar editor formats
 *  customScrollContainerStyles: custom styles for the quillScrollContainer element
 *  readOnly: make quill editable or not
 *  disableLineBreaks: prevent line breaks from being added to the text
 *  name: for admin forms
 *
 * Output Properties:
 *  textChanged: EventEmitter that emits when text is changed (as HTML string).
 *
 */
export class TextEditComponent {
    constructor(eltRef, rendererFactory, svgSpriteService) {
        this.eltRef = eltRef;
        this.rendererFactory = rendererFactory;
        this.svgSpriteService = svgSpriteService;
        this.name = null;
        this.hideFormats = false;
        this.extraFormats = [];
        this.readOnly = false;
        this.customScrollContainerStyles = {};
        this.disableLineBreaks = false;
        this.textChanged = new EventEmitter();
        this.quillEditor = null;
        this.defaultScrollContainerStyles = {
            'height': '350px',
            'max-height': '350px',
            'max-width': '582px',
            'overflow-y': 'auto',
        };
        this.scrollContainerStyles = {};
        this.formats = [];
        this.TOOLBAR_TYPES = QuillToolbarFormatType;
        this.showIcons = false;
        this.iconList = ICON_LIST;
        this.showLinkBox = false;
        this.linkHref = '';
        this.linkTarget = '_self';
        this.renderer = this.rendererFactory.createRenderer(null, null);
        const text = this.eltRef.nativeElement.getAttribute('text') || '';
        const name = this.eltRef.nativeElement.getAttribute('name') || null;
        const extraFormats = this.eltRef.nativeElement.getAttribute('extraFormats') || '[]';
        const customScrollContainerStyles = this.eltRef.nativeElement.getAttribute('customScrollContainerStyles') || '{}';
        this.text = text;
        this.name = name;
        this.extraFormats = JSON.parse(extraFormats);
        this.customScrollContainerStyles = JSON.parse(customScrollContainerStyles);
    }
    onClick(event) {
        if (!this.iconContainer)
            return;
        if (this.iconContainer && !this.iconContainer.nativeElement.contains(event.target)) {
            this.closeIcons();
        }
    }
    ngOnInit() {
        this.scrollContainerStyles = { ...this.defaultScrollContainerStyles, ...this.customScrollContainerStyles };
        this.formats = [...this.extraFormats, ...BASE_TOOLBAR_FORMATS];
    }
    async ngAfterViewInit() {
        const Quill = (await import('quill')).default;
        let Embed;
        if (this.formats.includes(QuillToolbarFormatType.DATE_EMBED) ||
            this.formats.includes(QuillToolbarFormatType.YCNICON)) {
            Embed = Quill.import('blots/embed');
        }
        if (this.formats.includes(QuillToolbarFormatType.DATE_EMBED)) {
            class SpanEmbed extends Embed {
                static create(value) {
                    const node = super.create(value);
                    node.style = 'font-style: italic; color: rgb(102, 102, 102);';
                    node.innerText = value;
                    return node;
                }
            }
            SpanEmbed.blotName = 'dateEmbed';
            SpanEmbed.tagName = 'dateEmbed';
            Quill.register(SpanEmbed);
        }
        if (this.formats.includes(QuillToolbarFormatType.TARGET_LINK)) {
            const Link = Quill.import('formats/link');
            class TargetLink extends Link {
                static parseValue(value) {
                    let newValue;
                    try {
                        newValue = JSON.parse(value);
                    }
                    catch (e) {
                        newValue = value;
                    }
                    return newValue;
                }
                static create(value) {
                    const node = super.create();
                    const newValue = TargetLink.parseValue(value);
                    if (typeof newValue !== 'string') {
                        node.setAttribute('href', newValue.href);
                        node.setAttribute('target', newValue.target);
                        return node;
                    }
                    node.setAttribute('href', newValue);
                    return node;
                }
                static formats(domNode) {
                    return JSON.stringify({
                        href: domNode.getAttribute('href'),
                        target: domNode.getAttribute('target'),
                    });
                }
                format(name, value) {
                    if (name !== this.statics.blotName || !value) {
                        super.format(name, value);
                    }
                    const newValue = TargetLink.parseValue(value);
                    if (typeof newValue !== 'string') {
                        this.domNode.setAttribute('href', newValue.href);
                        this.domNode.setAttribute('target', newValue.target);
                    }
                    else {
                        this.domNode.setAttribute('href', newValue);
                    }
                }
            }
            TargetLink.blotName = 'link';
            TargetLink.tagName = 'A';
            Quill.register(TargetLink, true);
        }
        if (this.formats.includes(QuillToolbarFormatType.YCNICON)) {
            class YcnIconEmbed extends Embed {
                static create(html) {
                    const node = super.create();
                    node.innerHTML = html;
                    return node;
                }
            }
            YcnIconEmbed.blotName = 'ycnIcon';
            YcnIconEmbed.tagName = 'ycnIcon';
            Quill.register(YcnIconEmbed);
        }
        const quillOptions = {
            modules: {
                toolbar: this.readOnly ? false : { container: this.quillToolbarContainer.nativeElement },
            },
            formats: this.formats,
            theme: 'snow',
            bounds: this.quillEditorContainer.nativeElement,
            readOnly: this.readOnly,
        };
        if (this.disableLineBreaks) {
            quillOptions.modules.keyboard = {
                bindings: {
                    enter: {
                        key: 13,
                        handler: () => {
                            return false;
                        },
                    },
                },
            };
            // Wrap the text in a paragraph tag so that it is displayed correctly in the Quill Editor
            if (!this.text.startsWith('<p>') && !this.text.endsWith('</p>')) {
                this.text = `<p>${this.text}</p>`;
            }
        }
        this.quillEditor = new Quill(this.quillEditorContainer.nativeElement, quillOptions);
        this.quillEditor.on('text-change', () => {
            const newText = this.quillEditor?.root.innerHTML;
            const today = formatDate(new Date(), 'M/d/yyyy', 'en-US', 'UTC');
            // Removing the contenteditable span since a new one gets added every time the quill editor is opened
            const pattern = /<dateEmbed style="font-style: italic; color: rgb\(102, 102, 102\);">(.+?)<span contenteditable="false">(.+?)<\/span>(.+?)<\/dateEmbed>/g;
            const replacement = `<dateEmbed style="font-style: italic; color: rgb(102, 102, 102);">${today}</dateEmbed>`;
            let outputString = newText?.replace(pattern, replacement);
            // Removing the contenteditable span for ycnicon
            const startIconPattern = /<ycnicon>(.+?)<span contenteditable="false">/g;
            const endIconPattern = /<\/span>(.+?)<\/ycnicon>/g;
            outputString = outputString?.replace(startIconPattern, '<ycnicon>');
            this.outputString = outputString?.replace(endIconPattern, '</ycnicon>') || '';
            this.textChanged.emit(`<span class="ql-editor">${this.outputString}</span>`);
        });
        // We are using `this.quillEditor.root.innerHTML` instead of Quill API (with something like
        // `this.quillEditor.clipboard.dangerouslyPasteHTML(this.text)`) because it does not work as expected: For some
        // reason, the method gets rid of line breaks, changing the saved HTML just because.
        this.setText(this.text);
        // Hide the toolbar box when this.hideFormats === true
        if (this.quillToolbarContainer) {
            this.quillToolbarContainer.nativeElement.style.display = this.hideFormats ? 'none' : 'block';
        }
    }
    removeQLEditorWrapper(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const outerDiv = doc.body.firstElementChild;
        if (outerDiv && outerDiv.tagName === 'SPAN' && outerDiv.classList.contains('ql-editor')) {
            const { innerHTML } = outerDiv;
            return innerHTML;
        }
        return htmlString;
    }
    setText(text) {
        if (this.quillEditor) {
            this.quillEditor.root.innerHTML = this.removeQLEditorWrapper(text);
        }
    }
    addDynamicDate() {
        const selection = this.quillEditor?.getSelection(true);
        const today = formatDate(new Date(), 'M/d/yyyy', 'en-US', 'UTC');
        if (this.quillEditor) {
            this.quillEditor.insertEmbed(selection.index, 'dateEmbed', today);
            this.quillEditor.setSelection(selection.index + 1, 0);
        }
    }
    showAddLink() {
        this.showLinkBox = !this.showLinkBox;
    }
    addLink() {
        if (this.quillEditor) {
            const selection = this.quillEditor.getSelection();
            this.quillEditor.focus();
            if (selection) {
                this.quillEditor.formatText(selection?.index, selection?.length, 'link', {
                    href: this.linkHref,
                    target: this.linkTarget,
                });
                this.showLinkBox = false;
            }
        }
    }
    async selectIcon(icon) {
        const selection = this.quillEditor?.getSelection(true);
        const container = this.renderer.createElement('svg');
        const ycDirective = new IconDirective({ nativeElement: container }, this.rendererFactory, this.svgSpriteService);
        ycDirective.name = icon;
        // Use synchronous creation since we're manually instantiating the directive
        // and lifecycle hooks won't be called
        ycDirective.createIconSync();
        if (this.quillEditor) {
            this.quillEditor.insertEmbed(selection.index, QuillToolbarFormatType.YCNICON, container.outerHTML);
            this.quillEditor.setSelection(selection.index + 1, 0);
        }
        this.closeIcons();
    }
    toggleIcons() {
        this.showIcons = !this.showIcons;
    }
    closeIcons() {
        this.showIcons = false;
    }
}
TextEditComponent.ɵfac = function TextEditComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TextEditComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.RendererFactory2), i0.ɵɵdirectiveInject(i1.SvgSpriteService)); };
TextEditComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextEditComponent, selectors: [["ycn-text-edit"]], viewQuery: function TextEditComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.quillEditorContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.quillToolbarContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iconContainer = _t.first);
    } }, hostBindings: function TextEditComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function TextEditComponent_click_HostBindingHandler($event) { return ctx.onClick($event); }, i0.ɵɵresolveDocument);
    } }, inputs: { text: "text", name: "name", hideFormats: "hideFormats", extraFormats: "extraFormats", readOnly: "readOnly", customScrollContainerStyles: "customScrollContainerStyles", disableLineBreaks: "disableLineBreaks" }, outputs: { textChanged: "textChanged" }, standalone: false, decls: 6, vars: 4, consts: [["quillEditorContainer", ""], ["quillToolbarContainer", ""], ["iconContainer", ""], [4, "ngIf"], [3, "ngStyle"], ["type", "hidden", 3, "name", "value"], [4, "ngFor", "ngForOf"], [3, "ngSwitch"], ["class", "ql-size", 4, "ngSwitchCase"], ["class", "ql-bold", 4, "ngSwitchCase"], ["class", "ql-italic", 4, "ngSwitchCase"], ["class", "ql-underline", 4, "ngSwitchCase"], ["class", "ql-addDate", 3, "click", 4, "ngSwitchCase"], ["class", "ql-link", 4, "ngSwitchCase"], ["class", "ql-list", "value", "ordered", 4, "ngSwitchCase"], ["class", "ql-list", "value", "bullet", 4, "ngSwitchCase"], ["class", "ql-image", "value", "image", 4, "ngSwitchCase"], ["class", "ycnIcon ql-picker ql-color-picker", 3, "ngClass", 4, "ngSwitchCase"], ["class", "link", "tabIndex", "0", "role", "button", "type", "button", 3, "mousedown", 4, "ngSwitchCase"], [1, "ql-size"], ["value", "small"], ["selected", ""], ["value", "large"], ["value", "huge"], [1, "ql-bold"], [1, "ql-italic"], [1, "ql-underline"], [1, "ql-addDate", 3, "click"], [1, "ql-link"], ["value", "ordered", 1, "ql-list"], ["value", "bullet", 1, "ql-list"], ["value", "image", 1, "ql-image"], [1, "ycnIcon", "ql-picker", "ql-color-picker", 3, "ngClass"], ["tabIndex", "0", "role", "button", "type", "button", 3, "mousedown"], ["ycnIcon", "", "name", "icon-y-logo", 2, "fill", "#666", "height", "14px"], [1, "ql-picker-options"], ["type", "button", 1, "ql-picker-item", "ql-primary"], ["type", "button", 1, "ql-picker-item", "ql-primary", 3, "click"], ["ycnIcon", "", 3, "name"], ["tabIndex", "0", "role", "button", "type", "button", 1, "link", 3, "mousedown"], ["ycnIcon", "", "name", "icon-link", 2, "fill", "#666", "height", "14px"], ["type", "text", "placeholder", "Link URL", 3, "ngModelChange", "ngModel"], [3, "ngModelChange", "ngModel"], ["value", "_blank"], ["value", "_self"], ["tabIndex", "0", "role", "button", "type", "button", 3, "click"]], template: function TextEditComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TextEditComponent_div_0_Template, 3, 1, "div", 3);
        i0.ɵɵconditionalCreate(1, TextEditComponent_Conditional_1_Template, 9, 2, "div");
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵelement(3, "div", null, 0);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(5, TextEditComponent_Conditional_5_Template, 1, 2, "input", 5);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showLinkBox ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", ctx.scrollContainerStyles);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.name ? 5 : -1);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgStyle, i2.NgSwitch, i2.NgSwitchCase, i3.IconDirective, i4.NgSelectOption, i4.ɵNgSelectMultipleOption, i4.DefaultValueAccessor, i4.SelectControlValueAccessor, i4.NgControlStatus, i4.NgModel], encapsulation: 2 });
